import * as ActionType from "../actionType";
import { fetchCareerPageApi } from "../../services/page/career";

const getCareerPageAction = () => {
  return async dispatch => {
    dispatchCareerPage(dispatch);
  };
};

const dispatchCareerPage = dispatch => {
  fetchCareerPageApi().then(data => {
    dispatch({
      type: ActionType.RECEIVE_PAGE_CAREER,
      data
    });
  });
};

export { getCareerPageAction, dispatchCareerPage };


// WEBPACK FOOTER //
// ./src/actions/page/career.js